import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { ThemeProvider } from "@mui/material";
import { theme } from "./theme/theme";
import { RouterProvider } from "react-router-dom";
import router from "./router";
import "./helpers/translations";
import { FeedContextProvider } from "./helpers/feed/FeedContextProvider";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const App = () => {
  return (
    <>
      <FeedContextProvider>
        <ThemeProvider theme={theme}>
          <RouterProvider router={router} />
        </ThemeProvider>
      </FeedContextProvider>
      {/* )} */}
    </>
  );
};

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
